import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const Dashboard = lazy(() => import("../../pages/dashboard/Dashboard"))

export const DashboardRouteImport = {
    RoutesMap,
    Dashboard
}